export default __webpack_public_path__ + "static/media/home-interior-design-portfolio-img03.8a08163d.jpg";